import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RolesWeb } from 'src/app/core/enums/roles.enum';
import { BranchOfficeModel } from 'src/app/core/models/branch-office.model';
import { UserResponsibleModel } from 'src/app/core/models/user-responsible.model';
import { MyCommerceService } from 'src/app/core/services/my-commerce.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { PaymentsService } from 'src/app/core/services/payments.service';
import { SessionCacheService } from 'src/app/core/services/session-cache.service';
import { UserService } from 'src/app/core/services/user.services';
import { QRDialogComponent } from 'src/app/shared/components/qr-dialog/qr-dialog.component';
import { IdentityService } from 'src/app/core/services/identity.service';

@Component({
  selector: 'app-branch-info',
  templateUrl: './branch-info.component.html',
  styleUrls: ['./branch-info.component.scss']
})
export class BranchInfoComponent implements OnInit, OnDestroy {
  @Input() branch: BranchOfficeModel;
  @Input() loggedUser: any;
  @Input() userModel: any;
  @Output() resetShowInfo: EventEmitter<boolean> = new EventEmitter(false);

  cajas: any;
  loadingData: boolean = false;
  loading: boolean = false;
  selectedBranch: any = null;
  responsables: UserResponsibleModel[];
  private sessionDataSubscription: Subscription;

  constructor(
    private myCommerceService: MyCommerceService,
    private router: Router,
    private paymentsService: PaymentsService,
    private dialog: MatDialog,
    private userService: UserService,
    private notificationService: NotificationService,
    private sessionCacheService: SessionCacheService,
    private identityService: IdentityService
  ) {}

  ngOnInit(): void {
    this.getData();

    this.sessionDataSubscription = this.sessionCacheService.sessionData$.subscribe((deletedKey: string | null) => {
      if (deletedKey === 'update') {
        this.handleSessionDataChange();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sessionDataSubscription) {
      this.sessionDataSubscription.unsubscribe();
    }
  }

  get loggedUserIsResponsible(): boolean {
    return this.identityService.hasRolId(RolesWeb.RESPONSABLE);
  }

  async getData() {
    this.selectedBranch = this.branch;
    this.loadingData = true;
    this.selectedBranch = await this.myCommerceService.getSucursal(this.branch.id.toString());
    this.cajas = this.selectedBranch?.cajas;
    this.responsables = this.selectedBranch?.usuariosResponsables;
    this.loadingData = false;
  }

  goToAgregarCaja(isEdition: boolean = false, cajaid?: number, branchid?: number): void {
    isEdition
      ? this.router.navigate(['/user/my-commerce/cashiers/edit'], {
          queryParams: { cashier: cajaid, branch: branchid }
        })
      : this.router.navigate(['/user/my-commerce/cashiers/create']);
  }

  goBack() {
    this.router.navigate(['/user/my-commerce']);
  }

  private async handleSessionDataChange() {
    await this.getData();
  }

  generarQR(caja: any) {
    this.paymentsService.getQREMVco(this.branch.id, caja.id).then((qrData) => {
      this.dialog.open(QRDialogComponent, {
        data: { qrData: qrData, cashierName: caja.nombre }
      });
    });
  }

  editClickEventHandlerCahier(cashier: any): void {
    this.goToEditCaja(cashier.id, this.branch.id);
  }

  goToEditCaja(cashierId: number, branchId: number): void {
    this.goToAgregarCaja(true, cashierId, branchId);
  }

  editClickEventHandler(userResponsible: any): void {
    if (userResponsible.id) {
      this.userModel.usuarioId = userResponsible.id;
    } else {
      this.userModel.usuarioId = userResponsible.usuarioId;
    }
    this.goToEditResponsible(this.userModel);
  }

  goToEditResponsible(data: any): void {
    // this.communicationService.setData(data);
    this.goToAgregarUsuario(true);
  }

  goToAgregarUsuario(isEdition: boolean = false): void {
    isEdition
      ? this.router.navigate(['/user/my-commerce/responsible/edit'], {
          queryParams: { responsible: this.userModel.usuarioId }
        })
      : this.router.navigate(['/user/my-commerce/responsible/create']);
  }

  async removeClickEventHandler(userResponsible: UserResponsibleModel): Promise<void> {
    try {
      this.loading = true;
      if (this.selectedBranch) {
        this.loadingData = true;
      }
      let response = await this.userService.removeUserResponsible(userResponsible.email);
      if (response) {
        this.notificationService.showSuccess('Se elimino un usuario.');
        if (this.selectedBranch) {
          this.selectedBranch = await this.myCommerceService.getSucursal(this.selectedBranch.id);
          this.cajas = this.selectedBranch.cajas;
          this.responsables = this.selectedBranch.usuariosResponsables;
          this.sessionCacheService.deleteData('responsibles');
        }
        await this.getData();
      } else {
        throw new Error('No se pudo eliminar el usuario.');
      }
      this.loading = false;
      if (this.selectedBranch) {
        this.loadingData = false;
      }
    } catch (error) {
      this.loading = false;
      this.notificationService.showError(error.message);
    }
  }

  evaluarEstado(estado: string) {
    switch (estado) {
      case 'A':
        return 'Activo';
      case 'P':
        return 'Pendiente';
      case 'O':
        return 'Onboarding';
    }
  }

  sendResetShowInfo() {
    this.resetShowInfo.emit(false);
  }
}
